const puzzle = {
  id: "muWUrHfxMSJVEUt00fug",
  name: "A note of achievement",
  rebuses: [
    {
      clues: [
        {
          clueGroup: 0,
          id: "baf1f937-dafe-49a5-bfe9-3320c267d718",
          style: { width: "calc(33% - 10px)" },
          clueValues: [
            {
              type: "text",
              id: "ff2fc50e-5f95-4a9c-8057-ffeefba9fbd9",
              value: "Stalin",
              style: { width: "calc(100% - 10px)" },
              subtext: "Gorky Park",
            },
          ],
          solutionInfo: {
            solvedText: "",
            type: "text",
            possibleSolutions: [],
          },
          helperText: "",
          subtext: "",
          dependsOn: [],
        },
        {
          style: { width: "calc(33% - 10px)" },
          clueValues: [
            {
              value: "Sphinx",
              subtext: "Giza",
              style: { width: "calc(100% - 10px)" },
              id: "ccdd377c-e3a9-4da0-af5a-c11d6c8a1cc5",
              type: "text",
            },
          ],
          dependsOn: [],
          clueGroup: 0,
          subtext: "",
          solutionInfo: {
            solvedText: "",
            possibleSolutions: [],
            type: "text",
          },
          helperText: "",
          id: "9c20813d-4253-4a17-b70f-2bcea9d7e1e7",
        },
        {
          clueValues: [
            {
              type: "text",
              value: "Zlatan Ibrahimovic",
              subtext: "Malmo",
              id: "6d5a8ac4-963a-461d-9be5-ca5d58b7fe46",
              style: { width: "calc(100% - 10px)" },
            },
          ],
          clueGroup: 0,
          dependsOn: [],
          helperText: "",
          id: "9485250b-1b39-4fdf-9348-2417e9579a43",
          subtext: "",
          style: { width: "calc(33% - 10px)" },
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
        {
          id: "734e1d69-5985-4d33-b8cf-a8d53fba1277",
          helperText:
            "What part of the body is missing on the statues of Stalin in Gorky Park, Sphinx in Giza and Zlatan Ibrahimovic in Malmo?",
          solutionInfo: {
            solvedText: "",
            type: "text",
            possibleSolutions: [],
          },
          clueGroup: 0,
          style: { width: "calc(33% - 10px)" },
          subtext: "",
          dependsOn: [],
          clueValues: [
            {
              style: { width: "calc(100% - 10px)" },
              id: "8df4c054-50a3-4c29-aa7e-66aac83e4fc1",
              subtext: "",
              value: "workshop/muWUrHfxMSJVEUt00fug/15a.png",
              type: "image",
            },
          ],
        },
      ],
      style: {},
      solutionInfo: {
        solvedText: "Nose",
        possibleSolutions: [
          { value: "Nose", id: "af18d849-06be-43a2-9b11-b1e09076b5e9" },
        ],
        type: "text",
      },
      id: "0b3e0940-76b4-475a-b340-311d485625e2",
    },
    {
      clues: [
        {
          helperText:
            "It's a formula for photosynthesis. You drink x all the time.",
          subtext: "x = ?",
          solutionInfo: {
            possibleSolutions: [
              {
                id: "727d5fc9-2c55-4616-b6d6-29a4ad484d34",
                value: "Water",
              },
              { id: "d0e33930-b172-4052-bedf-0106af07d520", value: "H2O" },
            ],
            type: "text",
            solvedText: "Water",
          },
          id: "1356abdd-b658-4df4-af9e-286c04c0ed13",
          style: { width: "calc(33% - 10px)" },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              style: { width: "calc(100% - 10px)" },
              value: "workshop/muWUrHfxMSJVEUt00fug/14a.png",
              subtext: "",
              type: "image",
              id: "fc3eb370-ffd2-473a-93bb-04b6acfd2f53",
            },
          ],
        },
        {
          helperText: "This word opens the gates of Moria.",
          style: { width: "calc(33% - 10px)" },
          clueValues: [
            {
              value: "Friend",
              id: "59942c7e-526b-4cf3-9e2b-5366d78054d7",
              style: { width: "calc(100% - 10px)" },
              subtext: "elvish",
              type: "text",
            },
          ],
          id: "1e833163-bbc2-4e72-a456-121825406f0f",
          clueGroup: 0,
          dependsOn: [],
          solutionInfo: {
            solvedText: "Mellon",
            type: "text",
            possibleSolutions: [
              {
                value: "Melon",
                id: "66a3382c-340f-4da4-9ab2-c3c88e845f5e",
              },
              {
                id: "aaa9bb1f-e791-4bc7-a02e-d100351e93c3",
                value: "Mellon",
              },
            ],
          },
          subtext: "",
        },
      ],
      style: {},
      id: "2747b9e6-86ef-4a90-97f9-00489287238b",
      solutionInfo: {
        type: "text",
        possibleSolutions: [],
        solvedText: "Watermelon",
      },
    },
    {
      solutionInfo: {
        solvedText: "Diamonds",
        possibleSolutions: [
          {
            id: "f7b99113-d058-422c-af46-5416e80eb084",
            value: "Diamonds",
          },
          { value: "Diamond", id: "f2e394c1-19b3-4727-a310-70467770c9ba" },
        ],
        type: "text",
      },
      style: {},
      clues: [
        {
          clueValues: [
            {
              id: "78820156-918f-473e-85c5-3db01a837e46",
              type: "image",
              subtext: "",
              style: { width: "calc(100% - 10px)" },
              value: "workshop/muWUrHfxMSJVEUt00fug/11a.png",
            },
          ],
          style: { width: "calc(33% - 10px)" },
          clueGroup: 1,
          subtext: "",
          helperText: "He has a salad named after him.",
          id: "4df8d793-6d5c-45e2-b57d-c06894a9305c",
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                id: "56b46776-2683-4bf8-b2114-29",
                value: "Julius Caesar",
              },
              {
                id: "4cd0fdff-33a1-40f3-9483-30",
                value: "Caesar",
              },
              {
                id: "bdeb8c4c-3891-47fd-a402-31",
                value: "Cesar",
              },
              {
                id: "54981ae2-595e-4bf4-a2120-32",
                value: "Cezar",
              },
              {
                id: "54981ae2-8676-4bf4-a2120-32",
                value: "Julius Cesar",
              },
              {
                id: "54981ae2-8676-4bf4-a2120-32",
                value: "Julius Cezar",
              },
            ],
            solvedText: "Julius Caesar",
          },
          dependsOn: [],
        },
        {
          subtext: "",
          helperText: "Also the name of one of the main characters in Friends.",
          id: "59f44679-0ce4-475a-b829-8191c5f78d73",
          clueGroup: 1,
          dependsOn: [],
          solutionInfo: {
            possibleSolutions: [
              {
                id: "23924bd0-5301-414e-a359-72848b3f304d",
                value: "Rachel",
              },
            ],
            solvedText: "Rachel",
            type: "text",
          },
          style: { width: "calc(33% - 10px)" },
          clueValues: [
            {
              style: { width: "calc(100% - 10px)" },
              subtext: "",
              type: "image",
              value: "workshop/muWUrHfxMSJVEUt00fug/13a.png",
              id: "e03bff03-b986-4260-94b0-5707427703e8",
            },
          ],
        },
        {
          subtext: "",
          dependsOn: [],
          clueValues: [
            {
              id: "72aa9024-e590-4851-89cd-1b756ebfb96d",
              type: "image",
              subtext: "",
              style: { width: "calc(100% - 10px)" },
              value: "workshop/muWUrHfxMSJVEUt00fug/12a.png",
            },
          ],
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                value: "Hector",
                id: "5ff909ec-1278-4e05-9622-58da71cf91bf",
              },
            ],
            solvedText: "Hector",
          },
          id: "b452d569-5a56-40bd-b7e1-d2d6c20166a9",
          style: { width: "calc(33% - 10px)" },
          clueGroup: 1,
          helperText: "Troy's greatest warrior",
        },
        {
          helperText: "They are king, queen and jack of something.",
          id: "805a703e-45a6-4fb3-afcc-92f4e694bf89",
          solutionInfo: {
            solvedText: "",
            type: "text",
            possibleSolutions: [],
          },
          subtext: "",
          style: { width: "calc(33% - 10px)" },
          clueValues: [
            {
              style: { width: "calc(100% - 10px)" },
              type: "text",
              value: "Not a heart but red",
              subtext: "",
              id: "251cfc39-49bd-4ad6-a3b9-491b41d6444c",
            },
          ],
          dependsOn: [
            {
              value: "4df8d793-6d5c-45e2-b57d-c06894a9305c",
              id: "ad6e5f2c-dfbc-4589-a1ec-cc1e6e2d309a",
            },
            {
              id: "31f216c7-0dfa-4f53-a279-60948eb84562",
              value: "59f44679-0ce4-475a-b829-8191c5f78d73",
            },
            {
              value: "b452d569-5a56-40bd-b7e1-d2d6c20166a9",
              id: "8f15d561-4e41-43e4-810a-f8b1e6514f7d",
            },
          ],
          clueGroup: 0,
        },
      ],
      id: "19946152-5c4f-4c98-acfa-2da0253724fc",
    },
    {
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "3e79a952-017d-4115-b874-0de337bdc496",
            value: "Guinness World Records",
          },
          {
            id: "3e79a952-017d-4115-b874-0deaaaaaa6",
            value: "Guinness World Record",
          },
          {
            value: "Guinness",
            id: "fc84b02f-ad40-4613-bfc1-ebbccbbc050e",
          },
          {
            id: "69a54c7b-d59a-43c0-96e6-0484013cb328",
            value: "Guiness Book of Records",
          },
        ],
        solvedText: "Guinness World Records",
      },
      style: {},
      id: "f5a31e30-2232-45f5-9cd0-fe8c25c0105c",
      clues: [
        {
          solutionInfo: {
            solvedText: "",
            possibleSolutions: [],
            type: "text",
          },
          clueGroup: 1,
          dependsOn: [],
          clueValues: [
            {
              type: "text",
              value: "Nose",
              id: "8b36b4a1-e918-4907-b0df-b80ed6db4f6d",
              style: { width: "calc(100% - 10px)" },
              subtext: "",
            },
          ],
          subtext: "8.8cm (3.46in)",
          helperText: "",
          style: { width: "calc(33% - 10px)" },
          id: "0f4d1b59-2a01-40eb-adb7-97f035fe22cc",
        },
        {
          clueValues: [
            {
              subtext: "",
              style: { width: "calc(100% - 10px)" },
              id: "2a32d5d9-3842-4292-b72d-d057d6366a80",
              value: "Watermelon",
              type: "text",
            },
          ],
          subtext: "159 kg (350.5 lb)",
          style: { width: "calc(33% - 10px)" },
          dependsOn: [],
          solutionInfo: {
            solvedText: "",
            possibleSolutions: [],
            type: "text",
          },
          clueGroup: 2,
          id: "107a6629-e55b-4cea-9aad-f5bf7e67b2da",
          helperText: "",
        },
        {
          helperText: "",
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
          style: { width: "calc(33% - 10px)" },
          subtext: "24 679",
          clueValues: [
            {
              subtext: "",
              style: { width: "calc(100% - 10px)" },
              type: "text",
              value: "Diamonds",
              id: "d009459f-0a76-4ec4-a375-fbc665e829d4",
            },
          ],
          id: "2e5e5b24-2919-455e-919f-e77f77982683",
          clueGroup: 3,
        },
      ],
    },
  ],
};

export default puzzle;
